module.exports = __webpack_public_path__ + "img/SKMJ_car3.02b25796.jpg";